module.exports = __webpack_public_path__ + "GLD-LF-IM-Black.jpg?fb23a21d93d2dc892a3816a92eb6f804";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GLD-LF-IM-Black.jpg
// module id = 85
// module chunks = 0